/* eslint-disable @typescript-eslint/no-unused-vars */
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState, Dispatch } from 'react';
// import { ModalWrap } from '../../components/modal-wrap';
import {
  getUserIdList,
  getAdminServiceList,
  putServiceConfig,
  postServiceConfig,
  deleteServiceApi,
} from '../../../api';
import {
  CommonStatusStep,
  IAPIServiceConfigItem,
  ServiceBusiness,
} from '../../../model/api-modules';
import { SystemMenuId } from '../../../model/system/menu';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import getFormatMessage from '../../../locales/get-format-message';
import { AutoAntTable } from '../../../components/auto-ant-table';
import {
  CommonAddButton,
  CommonButton,
  CommonButtonGroup,
  MainButton,
} from '../../../components/button/main';
import { wrapRequestArea } from '../../../lib/http/lib';
import { CustomPopover } from '../../../components/custom-popover';
import styles from './index.module.scss';
import { AddService } from './add-dialog';
import { messageError, messageSuccess } from '../../../components/message';
import { omit } from 'lodash';
import {
  getExtraManageSites,
  getFirstManageSite,
  getNeedManageSites,
  getNeedSynSiteOptions,
  getSiteText,
  isMultiManageSite,
} from '../../../lib/multi-site';
import { showSyncModal } from '../lib/sync-helper';
import {
  getAntLastModifyColumn,
  getUserEmailBySite,
  renderValidateStatusCell,
} from '../lib/columns';
import { ModalWrap } from '../../../components/modal-wrap';
import {
  handleMultiSiteSubmitRes,
  multiSiteSubmitter,
} from '../download/lib/multi-site-helper';
import { getSupportUsers } from '../../../api/admin/rbac';
import { IRootState } from '../../../store/reducers';

export interface ISelectOptionItem {
  readonly label: string;
  readonly value: string;
}

export interface IPageServiceConfigListItem extends IAPIServiceConfigItem {
  PicUserIds: string[];
  CreatedUserId: string;
  LastModifiedUserId: string;
  allSiteServiceItems?: IPageSiteServiceConfigListItem[];
  site?: string;
}

export interface IPageSiteServiceConfigListItem extends IAPIServiceConfigItem {
  site?: string;
}

export const AdminCreateService = () => {
  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  const [serviceList, setServiceList] = useState<IPageServiceConfigListItem[]>(
    []
  );

  const [userLists, setUserLists] = useState<ISelectOptionItem[]>([]);
  const [dialogMode, setDialogMode] = useState<'add' | 'edit' | 'view'>();
  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [selectRow, setSelectRow] = useState<IPageServiceConfigListItem>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  menuDispatch({
    type: ReduxCommonActionType.SELECT_MENU_ID,
    result: SystemMenuId.ServiceOnline,
  });

  // 获取服务配置列表
  const getServiceList = async () => {
    setTableLoading(true);
    const allSiteServiceConfigs: Record<
      string,
      IAPIServiceConfigItem[] | null | undefined
    > = {};
    await Promise.all(
      getNeedManageSites().map(async (site) => {
        const list = await wrapRequestArea(getAdminServiceList, site);
        allSiteServiceConfigs[site] = list?.map((item) => {
          return { ...item, site };
        });
      })
    );
    const userInfos = await getSupportUsers();
    const serviceConfigs = allSiteServiceConfigs[getFirstManageSite()];
    if (!userInfos || !serviceConfigs) {
      setTableLoading(false);
      return;
    }

    const userOptions = userInfos.map((item) => {
      return {
        label: item.UserID?.split('@')[0],
        value: item.UserID,
      };
    });
    setUserLists(userOptions);

    // 添加UseId字段
    const cloneRes: IPageServiceConfigListItem[] = serviceConfigs
      .map((serviceItem) => {
        const picArray = serviceItem.Pic.split(',');
        const createdId = serviceItem.FounderID;
        const lastModifiedId = serviceItem.LastUpdaterID;
        const userIdArray: any[] = [];
        picArray.forEach((it) => {
          const resultItem = getUserEmailBySite(it);
          if (resultItem) {
            userIdArray.push(resultItem);
          }
        });
        const createdItem = userInfos.filter((i) => i.id === createdId);
        const lastModifiedItem = userInfos.filter(
          (i) => String(i.id) === String(lastModifiedId)
        );
        const lastModifiedUserId = isNaN(Number(lastModifiedId))
          ? lastModifiedId
          : lastModifiedItem[0]?.UserID;

        const allSiteServiceItems = getNeedManageSites()
          .map((site) => {
            const configs = allSiteServiceConfigs[site];
            return configs?.find((item) => item.Name === serviceItem.Name);
          })
          .filter(Boolean) as IAPIServiceConfigItem[];

        return {
          ...serviceItem,
          PicUserIds: userIdArray,
          CreatedUserId: createdItem.length !== 0 ? createdItem[0].UserID : '',
          LastModifiedUserId: lastModifiedUserId,
          allSiteServiceItems,
        };
      })
      .sort((a, b) => {
        if (a.ParentSort === b.ParentSort) {
          return a.Sort - b.Sort;
        }
        return a.ParentSort - b.ParentSort;
      });

    setServiceList(cloneRes);

    setTableLoading(false);
  };

  useEffect(() => {
    getServiceList();
  }, []);

  const onSelectChange = (
    newSelectedRowKeys: readonly number[] | readonly string[]
  ) => {
    // 全选
    if (newSelectedRowKeys.length === serviceList.length) {
      const currentSelectedRowKeys: any[] = [];
      newSelectedRowKeys.forEach((item) => {
        const serviceItem = serviceList.find((it) => it.id === item);
        if (serviceItem?.Business === ServiceBusiness.G6) {
          currentSelectedRowKeys.push(item);
        }
      });
      setSelectedRowKeys(currentSelectedRowKeys as number[]);
    } else {
      setSelectedRowKeys(newSelectedRowKeys as number[]);
    }
  };

  const syncToSingapore = () => {
    showSyncModal(async (syncSite) => {
      const singaporeServices = await wrapRequestArea(
        getAdminServiceList,
        syncSite
      );
      const singaporeUserList = await wrapRequestArea(getUserIdList, syncSite);
      if (!singaporeServices) {
        messageError('海外站点获取服务出错');
        return false;
      }
      const selectedServices = serviceList.filter((item) =>
        selectedRowKeys.includes(item.id)
      );
      const needSyncServicePrams = selectedServices.map((serviceItem) => {
        const singaporeService = singaporeServices.find(
          (item) => item.Name === serviceItem.Name
        );
        const updateInfo = omit(serviceItem, [
          'FounderID',
          'LastUpdaterID',
          'id',
          'cnConfig',
          'CreateTime',
          'CreatedUserId',
          'LastModifiedUserId',
          'ModifyTime',
          'PicUserIds',
          'allSiteServiceItems',
          'site',
        ]);

        if (!singaporeService) {
          return {
            ...updateInfo,
            id: undefined,
            Status: CommonStatusStep.Pending,
          };
        }
        return {
          ...singaporeService,
          ...updateInfo,
        };
      });

      const submitRes = await Promise.all(
        needSyncServicePrams.map((params) => {
          const paramId = params.id;
          const paramsUniqueName = params.UniqueName || '';
          if ('id' in params && paramId) {
            return wrapRequestArea(
              () =>
                putServiceConfig({
                  ...params,
                  UniqueName: paramsUniqueName,
                  id: paramId,
                }),
              syncSite
            );
          }
          return wrapRequestArea(
            () =>
              postServiceConfig({
                ...params,
                UniqueName: paramsUniqueName,
              }),
            syncSite
          );
        })
      );
      if (submitRes.some((item) => !item)) {
        messageError(getFormatMessage('failed_submit'));
        return false;
      }
      messageSuccess(getFormatMessage('successfully'));
      return true;
    });
  };

  const COLUMNS: any = [
    {
      title: getFormatMessage('sort'),
      key: 'Sort',
      fixed: 'left',
      width: 50,
      render: (_text: string, record: { ParentSort: number; Sort: number }) => (
        <span>{`${record.ParentSort} - ${record.Sort}`}</span>
      ),
      sorter: (
        a: { ParentSort: number; Sort: number },
        b: { ParentSort: number; Sort: number }
      ) => {
        if (a.ParentSort === b.ParentSort) {
          return a.Sort - b.Sort;
        }
        return a.ParentSort - b.ParentSort;
      },
      // defaultSortOrder: 'ascend',
    },
    {
      title: getFormatMessage('release_sort'),
      dataIndex: 'ReleaseSort',
      key: 'ReleaseSort',
      fixed: 'left',
      width: 80,
      sorter: (a: { ReleaseSort: number }, b: { ReleaseSort: number }) =>
        a.ReleaseSort - b.ReleaseSort,
    },
    {
      title: getFormatMessage('parent_name'),
      dataIndex: 'ParentName',
      key: 'ParentName',
      fixed: 'left',
      width: 100,
      sorter: (a: { ParentName: string }, b: { ParentName: string }) =>
        a.ParentName.localeCompare(b.ParentName),
    },
    {
      title: getFormatMessage('name_uppercase'),
      dataIndex: 'Name',
      key: 'Name',
      fixed: 'left',
      sorter: (a: { Name: string }, b: { Name: string }) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: getFormatMessage('unique_name'),
      dataIndex: 'UniqueName',
      key: 'UniqueName',
    },
    {
      title: getFormatMessage('subservice_names'),
      dataIndex: 'SubServiceNames',
      key: 'SubServiceNames',
      showTooltip: true,
      width: 200,
    },
    {
      title: getFormatMessage('business'),
      dataIndex: 'Business',
      key: 'Business',
      render: (_val: any, record: IPageServiceConfigListItem) => {
        return record.Business === 'g6' ? 'ingame' : record.Business;
      },
    },
    {
      title: getFormatMessage('support_type'),
      dataIndex: 'SupportType',
      key: 'SupportType',
      width: 60,
    },
    {
      title: getFormatMessage('pic'),
      dataIndex: 'PicUserIds',
      key: 'PicUserIds',
      showTooltip: true,
      render: (_val: any, record: IPageServiceConfigListItem) => {
        const picUserIds: string[] = [];
        record.PicUserIds.forEach((item) => {
          picUserIds.push(item.split('@')[0]);
        });
        return picUserIds.join();
      },
    },
    {
      title: getFormatMessage('service_path'),
      dataIndex: 'ServicePath',
      key: 'ServicePath',
      width: 200,
      render: (_val: any, record: IPageServiceConfigListItem) => {
        if (!isMultiManageSite()) {
          return (
            <CustomPopover content={record.ServicePath}>
              {record.ServicePath}
            </CustomPopover>
          );
        }
        if (
          record.allSiteServiceItems?.every(
            (item) => item.ServicePath === record.ServicePath
          )
        ) {
          return (
            <CustomPopover content={record.ServicePath}>
              {record.ServicePath}
            </CustomPopover>
          );
        }
        const multiPath = (
          <div className={styles.multiSiteCell}>
            <div>
              {getSiteText()}站点服务路径: {record.ServicePath}
            </div>

            {getExtraManageSites().map((site) => {
              return (
                <>
                  <div>
                    {getSiteText(site)}站点服务路径:
                    {record.allSiteServiceItems?.find(
                      (item) => item.site === site
                    )?.ServicePath || ''}{' '}
                  </div>
                </>
              );
            })}
          </div>
        );
        return <CustomPopover content={multiPath}>{multiPath}</CustomPopover>;
      },
    },
    getAntLastModifyColumn(
      {
        sorter: (a: { ModifyTime: Date }, b: { ModifyTime: Date }) => {
          return (
            new Date(a.ModifyTime).getTime() - new Date(b.ModifyTime).getTime()
          );
        },
        defaultSortOrder: 'descend',
      },
      userInfo
    ),
    {
      title: getFormatMessage('启用状态'),
      dataIndex: 'Status',
      key: 'Status',
      render: (_val: any, record: IPageServiceConfigListItem) => {
        const statusMap = getNeedManageSites().reduce<
          Record<string, CommonStatusStep>
        >((acc, site) => {
          acc[site] =
            record.allSiteServiceItems?.find((item) => item.site === site)
              ?.Status || CommonStatusStep.Pending;
          return acc;
        }, {});
        return renderValidateStatusCell(statusMap);
      },
    },
    {
      title: getFormatMessage('operate'),
      key: 'action',
      fixed: 'right',
      render: (_text: string, record: IPageServiceConfigListItem) => (
        <CommonButtonGroup>
          <CommonButton type="link" onClick={() => viewService(record)}>
            {getFormatMessage('查看')}
          </CommonButton>
          <CommonButton type="link" onClick={() => openService(record)}>
            {getFormatMessage('edit')}
          </CommonButton>
          <CommonButton
            danger
            type="link"
            disabled={record.allSiteServiceItems?.some(
              (item) => item.Status === CommonStatusStep.Resolve
            )}
            onClick={() => deleteService(record)}
          >
            {getFormatMessage('删除')}
          </CommonButton>
        </CommonButtonGroup>
      ),
    },
  ];

  const viewService = (record: IPageServiceConfigListItem) => {
    if (record) {
      setSelectRow(record);
      setDialogMode('view');
    }
  };

  const openService = (record: IPageServiceConfigListItem) => {
    if (record) {
      setSelectRow(record);
      setDialogMode('edit');
    }
  };

  const deleteService = (record: IPageServiceConfigListItem) => {
    if (record) {
      ModalWrap.warn({
        title: '删除服务配置',
        oKText: '确认',
        danger: true,

        cancelText: '取消',
        children: `是否确认删除【${record.Name}】的配置信息?`,
        async onOk() {
          const res = await multiSiteSubmitter((_m, site) => {
            return deleteServiceApi(record.UniqueName || record.Name);
          });
          const finalRes = handleMultiSiteSubmitRes(res);
          getServiceList();
          return finalRes;
        },
      });
    }
  };
  return (
    <div>
      {dialogMode && (
        <AddService
          info={selectRow}
          dialogMode={dialogMode}
          userLists={userLists}
          onClose={() => {
            setDialogMode(undefined);
            setSelectRow(undefined);
          }}
          onChange={() => {
            setDialogMode(undefined);
            setSelectRow(undefined);
            getServiceList();
          }}
        />
      )}
      <AutoAntTable
        loading={tableLoading}
        dataSource={serviceList || []}
        columns={COLUMNS}
        defaultPageSize={20}
        configFilter={{
          filters: [
            {
              name: 'add',
              render: () => {
                return (
                  <CommonAddButton
                    onClick={() => {
                      setDialogMode('add');
                    }}
                  >
                    创建服务
                  </CommonAddButton>
                );
              },
            },
            {
              name: 'sync',
              render: () => {
                return (
                  <div>
                    {getNeedSynSiteOptions().length > 0 && (
                      <MainButton
                        onClick={syncToSingapore}
                        style={{ marginRight: 10 }}
                        disabled={selectedRowKeys.length === 0}
                      >
                        {getFormatMessage('同步至其它站点')}
                      </MainButton>
                    )}
                  </div>
                );
              },
            },

            {
              name: 'Name',
              placeholder: '请输入名称搜索',
              type: 'search',
              place: 'right',
            },
          ],
        }}
        rowSelection={{
          selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: (record) => {
            const canSelectList = serviceList.filter(
              (item) => item?.Business === ServiceBusiness.G6
            );
            if (!record) {
              return {
                checked: canSelectList.length <= selectedRowKeys.length,
                indeterminate:
                  selectedRowKeys.length > 0 &&
                  canSelectList.length > selectedRowKeys.length,
                disabled: false,
              };
            }
            return {
              disabled: record?.Business !== ServiceBusiness.G6,
              tips:
                record?.Business !== ServiceBusiness.G6
                  ? '非InGame服务不可使用同步至其它站点'
                  : '',
            };
          },
        }}
      />
    </div>
  );
};
